import { Component, OnInit } from "@angular/core";

export const ERROR_UNAUTHORIZED = 'error unauthorized';

@Component({
    template: '<h1>Redirecting... Please wait</h1>'
})
export class OidcErrorUnauthorizedCallbackComponent implements OnInit {
    ngOnInit(): void {
        window.parent.postMessage(ERROR_UNAUTHORIZED);
    }
}
